import { render, staticRenderFns } from "./BookingBackLink.vue?vue&type=template&id=5664bf2a"
import script from "./BookingBackLink.vue?vue&type=script&lang=js"
export * from "./BookingBackLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports